export default __webpack_public_path__ + "static/media/GR00034-mentor_amulet_3.37af8151.svg";